export const SalesMenuList = [
    {
        title: "My Applications",
        iconStyle: imagepaths.LeadsIcon,
        iconActive: imagepaths.LeadsIconActive,
        to: "/app/leadmanagement",
        id: "leads",
    },
    {
        title: "Assigned to Opps",
        iconStyle: imagepaths.applicationImg,
        iconActive: imagepaths.applicationActiveImg,
        to: "/app/applications",
        id: "applications",
    },
    {
        title: "Policies",
        iconStyle: imagepaths.shieldIcon,
        iconActive: imagepaths.shieldIconActive,
        to: "/app/connectorhome",
        id: ["dataPrivacyModal", "dataStorageModal", "rbipolicy"],
        classChange: "mm-collapse",
        content: [
            {
                title: "Privacy Policy",
                iconStyle: imagepaths.PrivacyPolicy,
                iconActive: imagepaths.PrivacyPolicyActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataPrivacyModal",
                showTitle: true
            },
            {
                title: "Terms and Conditions",
                iconStyle: imagepaths.StoragePolicy,
                iconActive: imagepaths.StoragePolicyActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataStorageModal",
            }
        ],
    },
];
